import Banner from "@/components/banner";
import TitleBox from "@/components/title.vue";
import Address from "@/components/address.vue";
export default {
  name: "about-us",
  components: {
    Banner,
    TitleBox,
    Address,
  },
  data() {
    return {
      bannerImg: require("@/assets/banner/banner5.jpg"),
    };
  },
  methods: {},
};
